import { Stage } from "react-migration/domains/sites/typings/Stage";
import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";

export const useStagesByStageIds = (stageIds: string[]) => {
  const { stageByStageId } = useSnapshot(sitesPipelineStore);

  return stageIds.map((stageId) => stageByStageId[stageId] as Stage).filter(Boolean);
};
